import { styled } from '@mui/system';
import { Button, Paper, Typography } from '@mui/material';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { getContrastColor } from '#component/theme';

export const ButtonContainer = styled('div', {
  shouldForwardProp: prop =>
    prop !== 'isIntersecting' &&
    prop !== 'shipmentModuleEnabled'
})(({ theme, isIntersecting, shipmentModuleEnabled }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: shipmentModuleEnabled ? 'space-between' : 'end',
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),

  ...(!isIntersecting && {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: 'rgba(0, 0, 0, 0.45) 0px -17px 20px -22px'
  })
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1)
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  },
  '&:empty': {
    display: 'none'
  }
}));

export const AddButtonIcon = styled(AddCircleOutlineRoundedIcon)(() => ({
  color: getContrastColor()
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));
